<template>
  <label class="mb-0 text-mild">
    <input
      type="checkbox"
      :id="id"
      :name="name"
      v-model="inputValue"
      :checked="checked"
      class="d-none"
    />
    <FeatherIcon icon="square" v-show="!inputValue" size="18" />
    <FeatherIcon
      icon="check-square"
      v-show="inputValue"
      size="18"
      class="text-blue"
    />
    <span
      :for="id"
      class="ml-1 text-size-12"
      :class="{ 'text-blue': inputValue }"
      >{{ text }}</span
    >
  </label>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class AppCheckbox extends Vue {
  @Prop({
    type: Boolean,
    required: true
  })
  value!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  name!: string;

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  id!: string;

  @Prop({
    type: String,
    required: true,
    default: ""
  })
  text!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  checked!: boolean;

  get inputValue() {
    return this.value;
  }
  set inputValue(newVal: boolean) {
    if (this.value !== newVal) this.$emit("input", newVal);
  }
}
</script>

<style lang="scss" scoped>
.app-radio {
  &__input {
    display: none;
  }

  &__label {
    position: relative;
    display: flex;
    align-items: center;
    padding: 6px 8px;
    margin-bottom: 0;
    color: $primary-dark;
    background-color: $white;
    border: 1px solid $gray-04;
    border-radius: 4px;

    .app-radio__input:checked + & {
      border-color: $blue;
    }

    &::before {
      display: block;
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      margin-right: 8px;
      content: "";
      background-color: $gray-03;
      border-radius: 50%;

      .app-radio__input:checked + & {
        background-color: $blue;
        border: 4px solid $light-blue;
      }
    }
  }
}
</style>
